import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './hooks/useAuth';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import LoginUnificado from './pages/Login/LoginUnificado';
import MiEspacio from './pages/Cliente/MiEspacio';
import FormularioAsesoria from './pages/Asesoria/FormularioAsesoria';
import CalculadoraRiesgos from './pages/CalculadoraRiesgos/CalculadoraRiesgos';
import Blog from './pages/Blog/Blog';
import ArticuloDetalle from './pages/Blog/ArticuloDetalle';
import HeroSection from './components/landing/HeroSection';
import ServiciosSection from './components/landing/ServiciosSection';
import './App.css';

// Admin Pages
import DashboardAdmin from './pages/Admin/DashboardAdmin';
import ClientesAdmin from './pages/Admin/ClientesAdmin';
import CasosAdmin from './pages/Admin/CasosAdmin';
import DetalleCasoAdmin from './pages/Admin/DetalleCasoAdmin';
import AdminArticulos from './pages/Admin/AdminArticulos';
import SolicitudesAdmin from './pages/Admin/SolicitudesAdmin';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  const sessionData = sessionStorage.getItem('usuario');
  const isAdmin = sessionData && JSON.parse(sessionData).type === 'admin';
  return (user || isAdmin) ? children : <Navigate to="/login" />;
};

const ClienteRoute = ({ children }) => {
  const sessionData = sessionStorage.getItem('usuario');
  const isCliente = sessionData && JSON.parse(sessionData).type === 'cliente';
  return isCliente ? children : <Navigate to="/login" />;
};

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ServiciosSection />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <Header />
          <Routes>
            {/* Rutas publicas */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginUnificado />} />
            <Route path="/asesoria" element={<FormularioAsesoria />} />
            <Route path="/calculadora-riesgos" element={<CalculadoraRiesgos />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<ArticuloDetalle />} />
            
            {/* Rutas para clientes */}
            <Route path="/mi-espacio" element={<ClienteRoute><MiEspacio /></ClienteRoute>} />
            
            {/* Rutas para administradores */}
            <Route path="/dashboard" element={<PrivateRoute><DashboardAdmin /></PrivateRoute>} />
            <Route path="/clientes" element={<PrivateRoute><ClientesAdmin /></PrivateRoute>} />
            <Route path="/casos" element={<PrivateRoute><CasosAdmin /></PrivateRoute>} />
            <Route path="/casos/:id" element={<PrivateRoute><DetalleCasoAdmin /></PrivateRoute>} />
            <Route path="/admin/articulos" element={<PrivateRoute><AdminArticulos /></PrivateRoute>} />
            <Route path="/admin/solicitudes" element={<PrivateRoute><SolicitudesAdmin /></PrivateRoute>} />
          </Routes>
          <Footer />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;